module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-datetimepicker/~/core-js/library/modules/$.fails.js
// module id = 586
// module chunks = 0